module.exports = __webpack_public_path__ + "static/media/aws.4ad8d13a.svg";